import script from "./FormClasses.vue?vue&type=script&lang=ts"
export * from "./FormClasses.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__